import React from "react";
import SearchField from "../../atoms/SearchField";

/**
 * Liste arama kutusu — sınırlı genişlikte SearchField (uygulamadaki tek arama
 * kutusu görünümü). Debounce beklenirken sağda küçük bir spinner gösterir (isPending).
 *
 * onChange event değil, doğrudan string alır.
 */
export default function ListSearchInput({
  placeholder,
  value,
  onChange,
  isPending = false,
  sx = {},
}) {
  return (
    <SearchField
      placeholder={placeholder}
      value={value ?? ""}
      onChange={onChange}
      isPending={isPending}
      sx={{ width: { xs: "100%", sm: 240 }, ...sx }}
    />
  );
}
